import {Component, OnInit, Input, ChangeDetectorRef, OnChanges, inject} from '@angular/core';
import {Router} from '@angular/router';
import {NavService} from '@services/nav.service';
import {MediaMatcher} from '@angular/cdk/layout';
import {AppHorizontalNavItemComponent} from '@layout/full-layout/horizontal/sidebar/nav-item/nav-item.component';
import {CommonModule} from '@angular/common';
import {navItemsSuperadmin} from '@core/data/sidebar/sidebar-superadmin-data';

@Component({
  selector: 'app-horizontal-sidebar',
  imports: [AppHorizontalNavItemComponent, CommonModule],
  standalone: true,
  templateUrl: './sidebar.component.html',
})
export class AppHorizontalSidebarComponent implements OnInit {
  public navService: NavService = inject(NavService);
  public router: Router = inject(Router);
  media: MediaMatcher = inject(MediaMatcher);
  changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  navItems = navItemsSuperadmin;
  parentActive = '';

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor() {
    this.mobileQuery = this.media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe(
      () => (this.parentActive = this.router.url.split('/')[1])
    );
  }

  ngOnInit(): void {
    this.parentActive = this.router.url.split('/')[1];

    this.router.events.subscribe(() => {
      this.parentActive = this.router.url.split('/')[1];
    });
  }
}
